module.exports = __webpack_public_path__ + "img/stone-path-side.fc987836.png";